import { DigitalProduct } from "../../../../Redux/digital-product/types";

const ProudtcDetails = ({
  product,
  selectedVariation,
}: {
  product: DigitalProduct;
  selectedVariation: number;
}) => {
  if (!product) return null;

  return (
    <>
      <div className=" display-max">
        <div className="justify-content-center text-center align-items-start">
          <div className=" lh-1 mb-3">
            <h3 className=" text-black fw-normal">{product?.productName}</h3>

            <a href="#">
              <b className=" text-normal text-md text-decoration-line text-success">
                {product?.brand} Store
              </b>
            </a>
          </div>
          <div className=" lh-sm text-start mb-1">
            <b className=" text-black fw-normal fs-4">
              {product?.productDescription}
            </b>
          </div>
          <div className="mt-2">
            <div className=" mt-1">
              <span className=" badge badge-md badge-dark text-white text-capitalize">
                Salar's Choice
              </span>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" lh-1">
            {product?.pricingDetails?.offerPrice ? (
              <>
                <h2 className=" text-black fw-normal">
                  <sup className="fs-4 fw-light me-0">₹</sup>
                  {(() => {
                    const unitPrice = product?.pricingDetails?.unitPrice || 0;
                    const gstAmount = product?.pricingDetails?.gstAmount || 0;
                    const discountAmount =
                      product?.pricingDetails?.offerPrice || 0;

                    const offerPrice = unitPrice + gstAmount - discountAmount;
                    return offerPrice.toFixed(2);
                  })()}
                </h2>
                <div>
                  <b className=" text-danger fs-5 fw-normal">
                    <b className=" text-xs text-black me-1 fw-normal">
                      MRP:{" "}
                      <b className=" text-xs text-black text-decoration-line-through fw-normal">
                        ₹{" "}
                        {(() => {
                          const unitPrice =
                            product?.pricingDetails?.unitPrice || 0;
                          const gstAmount =
                            product?.pricingDetails?.gstAmount || 0;

                          const mrp = unitPrice + gstAmount || 0;
                          return mrp.toFixed(2);
                        })()}
                      </b>
                    </b>
                    (-
                    {(() => {
                      const unitPrice = product?.pricingDetails?.unitPrice || 0;
                      const gstAmount = product?.pricingDetails?.gstAmount || 0;
                      const discountAmount =
                        product?.pricingDetails?.offerPrice || 0;
                      const offerPrice = unitPrice + gstAmount - discountAmount;

                      const mrp = unitPrice + gstAmount || 0;

                      const discountPercentage =
                        ((mrp - offerPrice) / mrp) * 100 || 0;

                      return discountPercentage.toFixed(2);
                    })()}
                    % off)
                  </b>
                  <p className=" text-xxs fw-normal text-black">
                    Price inclusive of all taxes
                  </p>
                </div>
              </>
            ) : (
              <>
                <h2 className=" text-black fw-normal">
                  <sup className="fs-4 fw-light me-0">₹</sup>
                  {(() => {
                    const unitPrice = product?.pricingDetails?.unitPrice || 0;
                    const gstAmount = product?.pricingDetails?.gstAmount || 0;

                    const mrp = unitPrice + gstAmount || 0;
                    return mrp.toFixed(2);
                  })()}
                </h2>
                <p className=" text-xxs fw-normal text-black">
                  Price inclusive of all taxes
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob">
        <div className=" d-flex justify-content-between align-items-start p-2">
          <div>
            <h3 className=" text-black fw-normal">{product?.brand}</h3>
          </div>
          <div className=" d-flex justify-content-center align-items-center gap-2">
            <li className="avatar avatar-sm border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="ri-upload-2-line fs-5 text-black"></i>
              </a>
            </li>
            <li className="avatar avatar-sm  border-radius-2xl bg-gray-100">
              <a href=".">
                <i className="ri-heart-line fs-4 text-black"></i>
              </a>
            </li>
          </div>
        </div>
        <div className=" lh-sm text-start mb-1 ps-1">
          <b className=" text-black fw-normal text-sm">
            {product?.productDescription}
          </b>
        </div>
        <hr className=" horizontal dark" />
        <div className=" lh-1 ms-2">
          {product?.pricingDetails?.offerPrice ? (
            <>
              <h2 className=" text-black fw-normal">
                <sup className="fs-4 fw-light me-0">₹</sup>
                {(() => {
                  const unitPrice = product?.pricingDetails?.unitPrice || 0;
                  const gstAmount = product?.pricingDetails?.gstAmount || 0;
                  const discountAmount =
                    product?.pricingDetails?.offerPrice || 0;

                  const offerPrice = unitPrice + gstAmount - discountAmount;
                  return offerPrice.toFixed(2);
                })()}
              </h2>
              <div>
                <b className=" text-danger fs-5 fw-normal">
                  <b className=" text-xs text-black me-1 fw-normal">
                    MRP:{" "}
                    <b className=" text-xs text-black text-decoration-line-through fw-normal">
                      ₹{" "}
                      {(() => {
                        const unitPrice =
                          product?.pricingDetails?.unitPrice || 0;
                        const gstAmount =
                          product?.pricingDetails?.gstAmount || 0;

                        const mrp = unitPrice + gstAmount || 0;
                        return mrp.toFixed(2);
                      })()}
                    </b>
                  </b>
                  (-
                  {(() => {
                    const unitPrice = product?.pricingDetails?.unitPrice || 0;
                    const gstAmount = product?.pricingDetails?.gstAmount || 0;
                    const discountAmount =
                      product?.pricingDetails?.offerPrice || 0;
                    const offerPrice = unitPrice + gstAmount - discountAmount;

                    const mrp = unitPrice + gstAmount || 0;

                    const discountPercentage = ((mrp - offerPrice) / mrp) * 100;

                    return discountPercentage.toFixed(2);
                  })()}
                  % off)
                </b>
                <p className=" text-xxs fw-normal text-black">
                  Price inclusive of all taxes
                </p>
              </div>
            </>
          ) : (
            <>
              <h2 className=" text-black fw-normal">
                <sup className="fs-4 fw-light me-0">₹</sup>
                {(() => {
                  const unitPrice = product?.pricingDetails?.unitPrice || 0;
                  const gstAmount = product?.pricingDetails?.gstAmount || 0;

                  const mrp = unitPrice + gstAmount || 0;
                  return mrp.toFixed(2);
                })()}
              </h2>
              <p className=" text-xxs fw-normal text-black">
                Price inclusive of all taxes
              </p>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProudtcDetails;
